<template>
	<v-icon
		:icon="played ? 'mdi-replay' : 'mdi-play-circle-outline'"
		:disabled="onCooldown"
		size="32"
		@click="play"
		class="play-icon"
	/>
</template>

<script setup lang="ts">
import { ref } from "vue";
import type { AlternisMessage } from "../../../../store/alternis_new";
import { useAlternisNewStore } from "../../../../store/alternis_new";
import { useDomainStore } from "../../../../store/domain";
import router from "../../../../router";

const emits = defineEmits(["play"]);
const compProps = defineProps<{
	message: AlternisMessage;
	played: boolean;
}>();

const alternisNewStore = useAlternisNewStore();
const domainStore = useDomainStore();

const onCooldown = ref(false);

function play() {
	if (onCooldown.value) return;

	const domainId = domainStore.domain.id;
	if (!domainId) return;
	let workspaceId = router.currentRoute.value.params.workspaceId as string;
	if (!workspaceId) return;

	onCooldown.value = true;
	setTimeout(() => {
		onCooldown.value = false;
	}, 3000);

	emits("play");
	alternisNewStore.playTranslation(domainId, workspaceId, compProps.message.id);
}
</script>

<style scoped>
.play-icon {
	cursor: pointer;
	border-radius: 50%;
	width: 40px;
	height: 40px;
	transition: background-color 0.2s ease, opacity 0.2s ease, transform 0.1s ease;
}
.play-icon:hover {
	background-color: rgba(var(--v-theme-on-surface), 0.08);
}
.play-icon:active {
	transform: scale(0.9);
}
.play-icon:focus-visible {
	background-color: rgba(var(--v-theme-on-surface), 0.12);
}
.play-icon[disabled] {
	opacity: 0.4;
	pointer-events: none;
}
</style>
